export const formatDate = (date) => {
    return new Date(date).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });
};
export const formatContactData = (data) => {
    return data || "Not Available";
};
export const getContactClasses = (contact) => {
    return `card__content-contact-info ${!contact && 'card__content-contact-text-no-available'}`;
};